import {REGISTRY_SINGLETON} from '../../scenes/Registry';
import {playMeleeAnimation} from '../../scenes/playMeleeAnimation';
import {selectPendingMeleeDamage} from '../reducers/sharedStateReducer/selectors';

/**
 * Анимация ударов ближнего боя запускается здесь — после того, как экшен
 * расчета боя CALCULATE_MELEE_COMBAT_DAMAGE прошел редьюсер.
 *
 * ПОЧЕМУ MIDDLEWARE, А НЕ ХУКИ В МЕСТАХ ДИСПАТЧА. Расчет боя попадает в стор
 * множеством путей, и общего у них только сам стор: вход в этап из
 * handleCompleteTurn (свой ход, бот локальной партии, таймер хода,
 * автозавершение хода в обучении), клик по приоритетной цели в GameScene,
 * переброс костей в панели отряда, экшены по сети, действия ботов и запись
 * матча через playEffectForServerAction. Хук в каждом из них — это десяток
 * мест, одно из которых обязательно забудут.
 *
 * Стоит ПОСЛЕДНИМ в цепочке: экшен, который отбросили гейты выше (блокировка
 * ввода после нуля таймера, обучение, сюжетная реплика), сюда не доходит. К
 * моменту возврата из next поле уже перерисовано с итогом боя — анимация
 * прячет его и перерисовывает поле еще раз; кадр между двумя перерисовками не
 * успевает выйти.
 *
 * Песочницы ботов и сервер считают бой на своих сторах без этого middleware —
 * там анимации нет и быть не должно.
 */
export const createMeleeAnimationMiddleware = ({getHexGridRenderer, play = playMeleeAnimation}) => (
  (store) => (next) => (action) => {
    if (action?.type !== 'CALCULATE_MELEE_COMBAT_DAMAGE') {
      return next(action);
    }

    const previousPendingMeleeDamage = selectPendingMeleeDamage(store.getState());
    const result = next(action);

    const hexGridRenderer = getHexGridRenderer();
    if (hexGridRenderer) {
      try {
        play(store, hexGridRenderer, {
          payload: action.payload,
          previousPendingMeleeDamage,
          isFromServer: Boolean(action._fromServer),
        });
      } catch (error) {
        // Анимация — украшение: ее поломка не должна ронять диспатч
        console.warn('[Melee] не удалось запустить анимацию боя', error);
      }
    }

    return result;
  }
);

const meleeAnimationMiddleware = createMeleeAnimationMiddleware({
  getHexGridRenderer: () => REGISTRY_SINGLETON.getHexGridRenderer(),
});

export default meleeAnimationMiddleware;
